import { render, staticRenderFns } from "./statBlock.vue?vue&type=template&id=74f6df66&"
import script from "./statBlock.vue?vue&type=script&lang=js&"
export * from "./statBlock.vue?vue&type=script&lang=js&"
import style0 from "./statBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports